<template>
  <el-row :gutter="20">
    <el-col :span="12">
      <data-show label="账户类型：">
        {{dataObj.recAccountTypeDesc || '-'}}
      </data-show>
    </el-col>
    <el-col :span="12">
      <data-show label="账户名称：">
        {{dataObj.recAccountName || '-'}}
      </data-show>
    </el-col>
    <el-col :span="12">
      <data-show label="收款账户：">
        <page-encrypt-icon
          :value.sync="dataObj[`recAccountNumber-new`]"
          :encryptValue="dataObj.recAccountNumber"
        />
      </data-show>
    </el-col>
    <el-col :span="12">
      <data-show label="银行名称：">
        {{dataObj.recBankName || '-'}}
      </data-show>
    </el-col>
  </el-row>
</template>
<script>

export default {
  props: {
    dataObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>
